/* ──────────────────────────────────────────────────────────────
 *  Material and sleeve options
 *
 *  UI constants for material type selects. FEA regression
 *  coefficients (SHORE_GMOD_MAP, FEA_CALC_MAP) have been moved
 *  to the backend service layer.
 * ────────────────────────────────────────────────────────────── */

/** Sleeve / core material options shown in the Config dialog. */
export const MATERIAL_OPTIONS = ['Aluminum', 'Steel'] as const;
